import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { MembershipSessionService } from '../services/membership-session.service';

/** Contract 5.4: the OTP session token travels in this header on every /me/ call. */
export const MEMBERSHIP_TOKEN_HEADER = 'x-membership-token';

/**
 * Adds the OTP session token to /api/membership/me/* requests and to nothing else.
 *
 * The narrow match is deliberate: the /public/* endpoints are unauthenticated, and
 * an interceptor that sprayed a token at all of them would hide which calls really
 * depend on one.
 *
 * ⚠ ONE PUBLIC ENDPOINT IS AN EXCEPTION AND SETS THE HEADER ITSELF.
 * /public/purchase/initiate needs `x-membership-token` — the shipped handler reads
 * it from the header and its Joi schema REFUSES a `token` in the body, so the
 * contract's body-borne token was a 400 and a 401 at once. That header is set at
 * the call site in `MembershipApiService.initiatePurchase` rather than by widening
 * the rule here, so the exception is visible where it applies instead of being
 * buried in a URL match.
 */
export const membershipTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(MembershipSessionService).token;
  if (!token || !request.url.includes('/api/membership/me/')) {
    return next(request);
  }
  return next(request.clone({ setHeaders: { [MEMBERSHIP_TOKEN_HEADER]: token } }));
};
